<div class="mb-3" [formGroup]="group">
  <label [attr.for]="id">
    <ng-content select="[label]"></ng-content>
    <span class="text-danger" *ngIf="required"> *</span>
  </label>

  <input
    type="text"
    class="form-control"
    ngxDaterangepickerMd
    [id]="id"
    [showDropdowns]="false"
    [showCancel]="true"
    [showClearButton]="true"
    [linkedCalendars]="false"
    [singleDatePicker]="false"
    [autoApply]="true"
    [timePicker]="timePicker"
    [timePicker24Hour]="timePicker24Hour"
    [timePickerSeconds]="timePickerSeconds"
    [locale]="locale"
    [minDate]="minDate"
    [maxDate]="maxDate"
    formControlName="dateRange"
    [placeholder]="placeholder"
    (datesUpdated)="onRangeSelected($event)"
    (clearClicked)="reset()"
  />

  <i class="fa fa-calendar"></i>
</div>
